import { ITextbookCategory } from '~/types/textbook-category'
import http from '~/utils/http'

/** 获取所有教材分类 */
export function getTextbookCategory(
  page: number,
  size: number,
  parentId?: number,
) {
  return http.get('/admin/textbook/category', {
    params: {
      page,
      size,
      parentId,
    },
  })
}

/** 新增教材分类 */
export function postTextbookCategory(data: Partial<ITextbookCategory>) {
  return http.post('/admin/textbook/category', data)
}

/** 删除教材分类 */
export function deleteTextbookCategory(id: number) {
  return http.delete(`/admin/textbook/category/${id}`)
}

/** 编辑教材分类 */
export function patchTextbookCategory(
  id: number,
  data: Partial<ITextbookCategory>,
) {
  return http.patch(`/admin/textbook/category/${id}`, data)
}

export function getTextBookTree() {
  return http.get('/textbook/category/tree')
}
